(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[126],{

/***/ "1Wgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActiveIndexes; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_pull__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("jHPj");
/* harmony import */ var lodash_pull__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_pull__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("nnm9");
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("nnRT");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("pKEY");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(react_lazyload__WEBPACK_IMPORTED_MODULE_18__);


















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



var ActiveIndexes = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(ActiveIndexes, _Component);

  var _super = _createSuper(ActiveIndexes);

  function ActiveIndexes() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this, ActiveIndexes);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_this), "state", {
      activeIndexes: _this.props.activeIndexes || [],
      isPristine: true,
      lastIndex: 0
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_this), "clear", function () {
      _this.setState(function (prevState) {
        if (prevState.activeIndexes.length) {
          return {
            activeIndexes: []
          };
        }
      });
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_this), "update", function (index) {
      var _this$props$onUpdate = _this.props.onUpdate,
          onUpdate = _this$props$onUpdate === void 0 ? lodash_noop__WEBPACK_IMPORTED_MODULE_15___default.a : _this$props$onUpdate;
      var activeIndexes = _this.state.activeIndexes;
      var newActiveIndexes = activeIndexes.includes(index) ? _this.removeIndex(activeIndexes, index) : _this.addIndex(activeIndexes, index);

      _this.setState({
        activeIndexes: newActiveIndexes,
        isPristine: false,
        lastIndex: index
      }, function () {
        onUpdate(index);
        Object(react_lazyload__WEBPACK_IMPORTED_MODULE_18__["forceCheck"])();
      });
    });

    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(ActiveIndexes, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props$activeInd = this.props.activeIndexes,
          activeIndexes = _this$props$activeInd === void 0 ? [] : _this$props$activeInd;

      if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_16___default()(prevProps.activeIndexes, activeIndexes)) {
        var lastIndex = activeIndexes[activeIndexes.length - 1];
        this.setState({
          activeIndexes: activeIndexes,
          lastIndex: lastIndex >= 0 ? lastIndex : prevState.lastIndex
        });
      }
    }
  }, {
    key: "addIndex",
    value: function addIndex(activeIndexes, index) {
      var hasMultipleIndexEnabled = this.props.hasMultipleIndexEnabled;

      if (hasMultipleIndexEnabled) {
        return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(activeIndexes), [index]);
      }

      return [index];
    }
  }, {
    key: "removeIndex",
    value: function removeIndex(activeIndexes, index) {
      var hasNoIndexEnabled = this.props.hasNoIndexEnabled;

      if (hasNoIndexEnabled || activeIndexes.length > 1) {
        return lodash_pull__WEBPACK_IMPORTED_MODULE_14___default()(activeIndexes, index);
      }

      return activeIndexes;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        activeIndexes: this.state.activeIndexes,
        clear: this.clear,
        isPristine: this.state.isPristine,
        lastIndex: this.state.lastIndex,
        update: this.update
      });
    }
  }]);

  return ActiveIndexes;
}(react__WEBPACK_IMPORTED_MODULE_17__["Component"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(ActiveIndexes, "defaultProps", {
  activeIndexes: [],
  hasMultipleIndexEnabled: false,
  hasNoIndexEnabled: false
});

/***/ }),

/***/ "4/4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Tabs; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isFunction.js
var isFunction = __webpack_require__("2q8g");
var isFunction_default = /*#__PURE__*/__webpack_require__.n(isFunction);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.util.js
var tabs_util = __webpack_require__("GzVq");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.hoc.jsx
var tabs_hoc = __webpack_require__("lW4u");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/active-indexes/ActiveIndexes.jsx
var ActiveIndexes = __webpack_require__("1Wgj");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/tab-header/TabHeader.jsx + 1 modules
var TabHeader = __webpack_require__("ZKlR");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// CONCATENATED MODULE: ./src/client/components/frameworks/tabs/Tabs.themes.js
var themes = {
  "default": {
    thScrollable: 'w-full',
    thHeader: 'flex-col md:flex-row gap-5 md:items-center md:justify-between mb-20',
    thList: 'gap-5',
    thSlot: '',
    thBody: 'relative'
  },
  simple: {
    thList: 'pb-10 justify-between',
    thListItem: '',
    thSlot: 'pb-10'
  },
  underlined: {
    thHeader: 'flex-col md:flex-row md:items-center md:justify-between',
    thList: 'gap-10 md:gap-20 whitespace-nowrap',
    thListItem: 'flex-none',
    thSlot: 'flex items-center ms-auto top-full mt-10 absolute md:static md:mt-0 px-20 md:px-0 mb-5 end-0',
    thBody: 'py-20'
  },
  rounded: {
    thScrollable: 'flex-1',
    thListItem: 'flex-1',
    thBody: 'bg-white border-1 border-t-0 border-lightGrey rounded-b-12'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx















var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var Tabs_Tabs = function _Tabs(_ref) {
  var areAllCollapsable = _ref.areAllCollapsable,
      bgColor = _ref.bgColor,
      className = _ref.className,
      containerSize = _ref.containerSize,
      _ref$forceEnableHeade = _ref.forceEnableHeaderClick,
      forceEnableHeaderClick = _ref$forceEnableHeade === void 0 ? false : _ref$forceEnableHeade,
      hasControlsOnTouch = _ref.hasControlsOnTouch,
      hasBackground = _ref.hasBackground,
      isContainerWide = _ref.isContainerWide,
      isContentUnmountedOnCollapse = _ref.isContentUnmountedOnCollapse,
      _ref$initialSelectedI = _ref.initialSelectedItem,
      initialSelectedItem = _ref$initialSelectedI === void 0 ? 0 : _ref$initialSelectedI,
      id = _ref.id,
      isScrollable = _ref.isScrollable,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      onSelect = _ref.onSelect,
      onTabClick = _ref.onTabClick,
      scrollForwardLabel = _ref.scrollForwardLabel,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      slotLeft = _ref.slotLeft,
      slotRight = _ref.slotRight,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      message = _ref.message;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  if (!items.length) {
    return null;
  }

  var refsArray = [];
  var _themes$theme = themes[theme],
      thBody = _themes$theme.thBody,
      thHeader = _themes$theme.thHeader,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thScrollable = _themes$theme.thScrollable,
      thSlot = _themes$theme.thSlot;

  var tabUpdate = function tabUpdate(idx, update) {
    update(idx);
    refsArray[idx] && refsArray[idx].focus();
  };

  var _onKeyDown = function onKeyDown(_ref2) {
    var e = _ref2.e,
        index = _ref2.index,
        update = _ref2.update;

    if (items.length > 1) {
      var lastItem = items.length - 1;

      switch (e.which) {
        case keyCodes["c" /* ARROW_RIGHT */]:
        case keyCodes["a" /* ARROW_DOWN */]:
          e.preventDefault();
          tabUpdate(index === lastItem ? 0 : index + 1, update);
          break;

        case keyCodes["b" /* ARROW_LEFT */]:
        case keyCodes["d" /* ARROW_UP */]:
          e.preventDefault();
          tabUpdate(index === 0 ? lastItem : index - 1, update);
          break;

        case keyCodes["h" /* HOME */]:
          e.preventDefault();
          tabUpdate(0, update);
          break;

        case keyCodes["e" /* END */]:
          e.preventDefault();
          tabUpdate(lastItem, update);
          break;

        default:
      }
    }
  };

  var tabsCount = items.filter(Boolean).length;
  return __jsx(ActiveIndexes["a" /* ActiveIndexes */], {
    activeIndexes: [initialSelectedItem],
    hasNoIndexEnabled: areAllCollapsable,
    onUpdate: onSelect
  }, function (_ref3) {
    var update = _ref3.update,
        activeIndexes = _ref3.activeIndexes,
        lastIndex = _ref3.lastIndex;
    var els = items.filter(Boolean).map(function (_ref4, index) {
      var customHeader = _ref4.customHeader,
          _ref4$header = _ref4.header,
          header = _ref4$header === void 0 ? {} : _ref4$header,
          headerId = _ref4.headerId,
          panelId = _ref4.panelId;

      var onClick = function onClick() {
        tabUpdate(index, update);
        onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(headerId, index);
      };

      var isActive = activeIndexes.includes(index);

      var setRef = function setRef(ref) {
        refsArray[index] = ref;
      };

      var title = header.title,
          rest = Object(objectWithoutProperties["a" /* default */])(header, ["title"]);

      var headerProps = _objectSpread(_objectSpread({}, rest), {}, {
        className: thListItem,
        controlsId: panelId,
        id: headerId,
        isActive: isActive,
        isDisabled: forceEnableHeaderClick ? false : tabsCount <= 1,
        onClick: onClick,
        onKeyDown: function onKeyDown(e) {
          return _onKeyDown({
            e: e,
            index: index,
            update: update
          });
        },
        style: isRTL && isScrollable ? {
          direction: 'rtl'
        } : null,
        tabIndex: isActive || index === lastIndex ? 0 : -1
      });

      if (isFunction_default()(customHeader)) {
        return customHeader(headerProps, setRef);
      }

      return title && __jsx(TabHeader["a" /* TabHeader */], Object(esm_extends["a" /* default */])({}, headerProps, {
        key: headerId,
        ref: setRef,
        role: "tab",
        style: isRTL && isScrollable ? {
          direction: 'rtl'
        } : null,
        theme: theme
      }), title);
    });

    var tabsList = __jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('flex w-full', thList),
      role: "tablist"
    }, els);

    var hasActiveIndex = activeIndexes.length > 0 && !activeIndexes.includes(-1);
    return __jsx("section", {
      className: Object(classnames_utils["a" /* classnames */])('relative isolate', className),
      id: id,
      "data-cs-override-id": "Tabs" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
      ,
      "data-testid": "tabs"
    }, __jsx(SiteContainer["a" /* SiteContainer */], {
      className: "z-1",
      isWide: isContainerWide,
      size: containerSize
    }, __jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('flex', thHeader)
    }, slotLeft && __jsx("div", {
      className: thSlot
    }, slotLeft(activeIndexes)), isScrollable ? __jsx(Scrollable["a" /* Scrollable */], {
      backwardLabel: scrollBackwardLabel,
      className: thScrollable,
      forwardLabel: scrollForwardLabel,
      hasControlsOnTouch: hasControlsOnTouch,
      navPosition: "top",
      theme: "tabs"
    }, tabsList) : tabsList, slotRight && __jsx("div", {
      className: thSlot
    }, slotRight(activeIndexes)))), message && __jsx("div", {
      className: "justify-end md:flex"
    }, __jsx(Notification["a" /* Notification */], {
      className: "mb-20 md:order-1 md:mb-0",
      "data-testid": "specialOfferBlock",
      iconName: icons["a" /* ICONS */].SPECIAL_OFFERS
    }, __jsx(Text["a" /* Text */], {
      "data-testid": "specialOfferText",
      text: message,
      theme: "text-sans-n1"
    }))), __jsx("div", {
      "data-testid": "tabs-items-container",
      className: Object(classnames_utils["a" /* classnames */])(Object(defineProperty["a" /* default */])({}, Object(tabs_util["a" /* getTabsBackgroundClasses */])(hasBackground, bgColor), hasActiveIndex), thBody)
    }, items.filter(Boolean).map(function (_ref5, index) {
      var content = _ref5.content,
          headerId = _ref5.headerId,
          panelId = _ref5.panelId;
      var isActive = activeIndexes.includes(index);
      return (!isContentUnmountedOnCollapse || isActive) && __jsx("div", {
        "aria-hidden": !isActive,
        "aria-labelledby": headerId,
        className: Object(classnames_utils["a" /* classnames */])({
          'pointer-events-none invisible h-0 overflow-hidden': !isActive,
          'animation-duration-500 animate-fadeIn': isActive
        }),
        "data-cs-override-id": "Tabs-panel" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
        ,
        id: panelId,
        key: panelId,
        role: "tabpanel",
        "data-testid": "tabs-item-".concat(index, "-content")
      }, __jsx(SiteContainer["a" /* SiteContainer */], {
        isWide: isContainerWide,
        size: containerSize
      }, react["Children"].map(content, function (el, i) {
        return el ? /*#__PURE__*/Object(react["cloneElement"])(el, {
          key: "".concat(panelId, "-").concat(i),
          index: index
        }) : null;
      })));
    })));
  });
};

var Tabs = Object(tabs_hoc["a" /* withOpenAndScrollToHash */])(Tabs_Tabs);

/***/ }),

/***/ "4xcl":
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__("4ygQ");

/**
 * Converts `string`, as space separated words, to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.upperCase('--foo-bar');
 * // => 'FOO BAR'
 *
 * _.upperCase('fooBar');
 * // => 'FOO BAR'
 *
 * _.upperCase('__foo_bar__');
 * // => 'FOO BAR'
 */
var upperCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + word.toUpperCase();
});

module.exports = upperCase;


/***/ }),

/***/ "786X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Card_Card; });

// NAMESPACE OBJECT: ./src/client/components/frameworks/card/Card.layouts.jsx
var Card_layouts_namespaceObject = {};
__webpack_require__.r(Card_layouts_namespaceObject);
__webpack_require__.d(Card_layouts_namespaceObject, "Inline1", function() { return Card_layouts_Inline1; });
__webpack_require__.d(Card_layouts_namespaceObject, "Inline2", function() { return Card_layouts_Inline2; });
__webpack_require__.d(Card_layouts_namespaceObject, "Column1", function() { return Card_layouts_Column1; });
__webpack_require__.d(Card_layouts_namespaceObject, "Column2", function() { return Column2; });
__webpack_require__.d(Card_layouts_namespaceObject, "Composite1", function() { return Card_layouts_Composite1; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// EXTERNAL MODULE: ./src/client/components/frameworks/card/Card.constants.js
var Card_constants = __webpack_require__("syQ6");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-body/CardBody.themes.js

var defaultTheme = {
  thCta: 'font-bold underline',
  thCtaDefaultColor: colors["a" /* COLORS */].BLACK
};
var themes = {
  "default": defaultTheme,
  thumbnail: defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-body/CardBody.jsx




var __jsx = react_default.a.createElement;







var CardBody_CardBody = function CardBody(_ref) {
  var ctaLabel = _ref.ctaLabel,
      dataTestIdPrefix = _ref.dataTestIdPrefix,
      _ref$displayLoadMore = _ref.displayLoadMore,
      displayLoadMore = _ref$displayLoadMore === void 0 ? true : _ref$displayLoadMore,
      isTablet = _ref.isTablet,
      layout = _ref.layout,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? {} : _ref$text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = themes[theme],
      thCta = _themes$theme.thCta,
      thCtaDefaultColor = _themes$theme.thCtaDefaultColor;
  var isCollapsable = displayLoadMore && (!isTablet || [Card_constants["a" /* COLUMN_1 */], Card_constants["b" /* COLUMN_2 */]].includes(layout));
  return __jsx(react["Fragment"], null, __jsx(TextSeeMore["a" /* TextSeeMore */], Object(esm_extends["a" /* default */])({}, text, {
    dataTestIdPrefix: dataTestIdPrefix,
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: isCollapsable,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel
  })), __jsx(TextLink["a" /* TextLink */], Object(esm_extends["a" /* default */])({}, link, {
    className: Object(classnames_utils["a" /* classnames */])(thCta, {
      'mt-20': text === null || text === void 0 ? void 0 : text.text
    }),
    color: thCtaDefaultColor,
    iconName: icons["a" /* ICONS */].ARROW_TAIL_RIGHT,
    label: ctaLabel
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.small.js
var es_string_small = __webpack_require__("uFXj");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/card-heading/CardHeading.themes.js
var CardHeading_themes_themes = {
  "default": {
    thTitleTheme: 'title-brand-n2',
    thSmall: 'font-normal font-sans text-12',
    thSubtitle: 'text-sienna',
    thSubtitleTheme: 'title-sans-n2'
  },
  thumbnail: {
    thTitleTheme: 'title-brand-n3',
    thSmall: 'font-normal font-sans text-10',
    thSubtitle: 'text-sienna',
    thSubtitleTheme: 'title-sans-n2'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/card-heading/CardHeading.jsx



var CardHeading_jsx = react_default.a.createElement;





var CardHeading_CardHeading = function CardHeading(_ref) {
  var color = _ref.color,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'CardHeading' : _ref$dataTestIdPrefix,
      _ref$hLevel = _ref.hLevel,
      hLevel = _ref$hLevel === void 0 ? 2 : _ref$hLevel,
      iconName = _ref.iconName,
      link = _ref.link,
      small = _ref.small,
      subtitle = _ref.subtitle,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;

  if (!title) {
    return null;
  }

  var _themes$theme = CardHeading_themes_themes[theme],
      thSmall = _themes$theme.thSmall,
      thSubtitle = _themes$theme.thSubtitle,
      thSubtitleTheme = _themes$theme.thSubtitleTheme,
      thTitleTheme = _themes$theme.thTitleTheme; // eslint-disable-next-line clubmed/no-fake-component

  var withLink = function withLink(node) {
    return (link === null || link === void 0 ? void 0 : link.url) ? CardHeading_jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({}, link, {
      className: "block"
    }), node) : node;
  };

  return withLink(CardHeading_jsx(react["Fragment"], null, CardHeading_jsx(Title["a" /* Title */], {
    dataTestId: "".concat(dataTestIdPrefix, "-title"),
    hLevel: hLevel,
    iconName: iconName,
    theme: thTitleTheme
  }, title, !!small && CardHeading_jsx("small", {
    className: thSmall
  }, small)), !!subtitle && CardHeading_jsx(Title["a" /* Title */], {
    className: Object(classnames_utils["a" /* classnames */])(thSubtitle, "text-".concat(color || 'black')),
    dataTestId: "".concat(dataTestIdPrefix, "-subtitle"),
    hLevel: hLevel < 6 ? hLevel + 1 : 6,
    theme: thSubtitleTheme
  }, subtitle)));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/CardHeader.themes.js
var CardHeader_themes_defaultTheme = {
  thIntro: 'mt-20'
};
var CardHeader_themes_themes = {
  "default": CardHeader_themes_defaultTheme,
  thumbnail: CardHeader_themes_defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/CardHeader.jsx


var CardHeader_jsx = react_default.a.createElement;




var CardHeader_CardHeader = function CardHeader(_ref) {
  var color = _ref.color,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'CardHeader' : _ref$dataTestIdPrefix,
      heading = _ref.heading,
      introduction = _ref.introduction,
      link = _ref.link,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var thIntro = CardHeader_themes_themes[theme].thIntro;
  return CardHeader_jsx("header", null, CardHeader_jsx(CardHeading_CardHeading, Object(esm_extends["a" /* default */])({}, heading, {
    color: color,
    dataTestIdPrefix: dataTestIdPrefix,
    link: link,
    theme: theme
  })), !!introduction && CardHeader_jsx(Text["a" /* Text */], Object(esm_extends["a" /* default */])({}, introduction, {
    className: thIntro,
    "data-testid": "".concat(dataTestIdPrefix, "-introduction")
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/is-image/index.js
var is_image = __webpack_require__("JFtY");
var is_image_default = /*#__PURE__*/__webpack_require__.n(is_image);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Img.jsx + 1 modules
var Img = __webpack_require__("X6TF");

// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.utils.js
var Video_utils = __webpack_require__("JhHq");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.jsx
var Video = __webpack_require__("akds");

// CONCATENATED MODULE: ./src/client/components/frameworks/video-with-full-screen/VideoWithFullScreen.themes.js
var VideoWithFullScreen_themes_themes = {
  "default": {
    thThumbnailButton: 'hover:opacity-75 relative transition-opacity duration-250 ease-in w-full',
    thThumbnailButtonLabel: 'sr-only',
    thThumbnailIcon: 'absolute bg-black/60 leading-0 m-10 top-0 p-10 right-0 text-white',
    thThumbnailIconSize: '1.5625rem',
    thVideo: 'w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/video-with-full-screen/VideoWithFullScreen.jsx
var VideoWithFullScreen_jsx = react_default.a.createElement;









function VideoWithFullScreen(props) {
  var buttonLabel = props.buttonLabel,
      className = props.className,
      closeLabel = props.closeLabel,
      ratioKey = props.ratioKey,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      thumbnail = props.thumbnail,
      title = props.title,
      url = props.url;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setExpanded = _useState[1];

  if (!Object(Video_utils["b" /* isVideoUrl */])(url)) {
    return null;
  }

  if (!thumbnail) {
    return VideoWithFullScreen_jsx(Video["a" /* Video */], {
      className: className,
      ratioKey: ratioKey,
      url: url
    });
  }

  var _themes$theme = VideoWithFullScreen_themes_themes[theme],
      thIframe = _themes$theme.thIframe,
      thThumbnailButton = _themes$theme.thThumbnailButton,
      thThumbnailIcon = _themes$theme.thThumbnailIcon,
      thThumbnailIconSize = _themes$theme.thThumbnailIconSize,
      thThumbnailButtonLabel = _themes$theme.thThumbnailButtonLabel,
      thVideo = _themes$theme.thVideo;
  return VideoWithFullScreen_jsx(react["Fragment"], null, VideoWithFullScreen_jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])(thThumbnailButton, className),
    onClick: function onClick() {
      return setExpanded(!isExpanded);
    },
    type: "button"
  }, VideoWithFullScreen_jsx("span", {
    classnames: thThumbnailButtonLabel
  }, buttonLabel), VideoWithFullScreen_jsx(Image["a" /* Image */], {
    imageUrl: thumbnail,
    ratioKey: ratioKey
  }), VideoWithFullScreen_jsx("div", {
    className: thThumbnailIcon
  }, VideoWithFullScreen_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].MEDIA_VIDEO,
    width: thThumbnailIconSize
  }))), isExpanded && VideoWithFullScreen_jsx(Backdrop["a" /* Backdrop */], {
    ariaLabel: title,
    closeLabel: closeLabel,
    hasCloseButton: true,
    onClose: function onClose() {
      return setExpanded(!isExpanded);
    }
  }, VideoWithFullScreen_jsx(Video["a" /* Video */], {
    className: thVideo,
    iFrameClassName: thIframe,
    ratioKey: ratioKey,
    url: url
  })));
}
// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-media/CardMedia.themes.js

var CardMedia_themes_defaultTheme = {
  thImageRatio: ratios_utils["c" /* default */].M,
  thVideo: 'bg-black'
};
var CardMedia_themes_themes = {
  "default": CardMedia_themes_defaultTheme,
  thumbnail: CardMedia_themes_defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-media/CardMedia.jsx


var CardMedia_jsx = react_default.a.createElement;











var CardMedia_CardMedia = function CardMedia(_ref) {
  var children = _ref.children,
      closeLabel = _ref.closeLabel,
      hasFullScreenMode = _ref.hasFullScreenMode,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? {} : _ref$media,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;
  var _themes$theme = CardMedia_themes_themes[theme],
      thVideo = _themes$theme.thVideo,
      thImageRatio = _themes$theme.thImageRatio;
  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'fullScreen',
    labelGA: "blockTitle_".concat(title)
  });

  var _useState = Object(react["useState"])(false),
      shouldDisplayFullScreen = _useState[0],
      setShouldDisplayFullScreen = _useState[1];

  var _useState2 = Object(react["useState"])(0),
      zoomLevel = _useState2[0],
      setZoomLevel = _useState2[1]; // eslint-disable-next-line clubmed/no-fake-component


  var withLink = function withLink(node) {
    return node && link && link.url ? CardMedia_jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({}, link, {
      className: "block"
    }), node) : node;
  };

  return CardMedia_jsx(react["Fragment"], null, is_image_default()(media.url || '') ? withLink(CardMedia_jsx(react["Fragment"], null, hasFullScreenMode && CardMedia_jsx(react["Fragment"], null, CardMedia_jsx("button", {
    onClick: function onClick() {
      setShouldDisplayFullScreen(true);
      track();
    },
    className: "absolute end-0 top-0 m-15 rounded-2 bg-white p-5 leading-0 text-black shadow-sm transition-bg-color duration-250 ease-in hocus:bg-black/60 hocus:text-white",
    type: "button"
  }, CardMedia_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].EXPAND,
    width: "1.25rem"
  })), shouldDisplayFullScreen && CardMedia_jsx(Backdrop["a" /* Backdrop */], {
    onClose: function onClose() {
      setShouldDisplayFullScreen(false);
      setZoomLevel(0);
    },
    hasCloseButton: true
  }, zoomLevel === 0 ? CardMedia_jsx(Img["a" /* Img */], {
    dontChangeAnything: true,
    altMsg: media.alt,
    url: media.url,
    ratioDisplay: 1
  }) : CardMedia_jsx("div", {
    className: "max-h-full overflow-scroll"
  }, CardMedia_jsx(Img["a" /* Img */], {
    dontChangeAnything: true,
    altMsg: media.alt,
    url: media.url,
    ratioDisplay: 1,
    className: "mx-auto block",
    style: {
      maxWidth: "".concat(100 + zoomLevel * 100, "%")
    }
  })), CardMedia_jsx("div", {
    className: "absolute bottom-0 flex gap-x-10 p-20"
  }, CardMedia_jsx("button", {
    className: "animation-duration-500 relative top-0 z-3 flex size-26 items-center justify-center rounded-2 bg-white text-12 leading-0 text-black shadow transition-colors duration-250 ease-in ltr:animate-slideInRight rtl:animate-slideInLeft",
    onClick: function onClick() {
      zoomLevel <= 4 ? setZoomLevel(zoomLevel + 1) : setZoomLevel(5);
    },
    type: "button"
  }, CardMedia_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PLUS
  })), CardMedia_jsx("button", {
    className: "animation-duration-500 relative top-0 z-3 flex size-26 items-center justify-center rounded-2 bg-white text-12 leading-0 text-black shadow transition-colors duration-250 ease-in ltr:animate-slideInRight rtl:animate-slideInLeft",
    onClick: function onClick() {
      zoomLevel >= 1 ? setZoomLevel(zoomLevel - 1) : setZoomLevel(0);
    },
    type: "button"
  }, CardMedia_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].MINUS
  }))))), CardMedia_jsx(Image["b" /* default */], {
    altMsg: media.alt,
    imageUrl: media.url,
    ratioKey: media.ratioKey || thImageRatio,
    ratioDisplay: media.ratioDisplay || 1 / 2
  }))) : CardMedia_jsx(VideoWithFullScreen, {
    buttonLabel: media.thumbnailLabel,
    className: thVideo,
    closeLabel: closeLabel,
    thumbnail: media.thumbnail || '',
    title: media.title,
    url: media.url
  }), withLink(children));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/Card.layouts.jsx
var Card_layouts_jsx = react_default.a.createElement;


var mediaClasses = 'overflow-hidden relative';
var Card_layouts_Inline1 = function Inline1(header, body, media, dataTestIdForTextDiv) {
  return Card_layouts_jsx("div", {
    className: "flex flex-col sm:flex-row sm:items-start gap-20 sm:justify-between"
  }, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12 sm:w-1/2')
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'sm:w-1/2': media
    }),
    "data-testid": dataTestIdForTextDiv
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-20'
  }, body)));
};
var Card_layouts_Inline2 = function Inline2(header, body, media, dataTestIdForTextDiv) {
  return Card_layouts_jsx("div", {
    className: "flex flex-col sm:flex-row-reverse sm:items-start gap-20 sm:justify-between"
  }, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12 sm:w-1/2')
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'sm:w-1/2': media
    }),
    "data-testid": dataTestIdForTextDiv
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-20'
  }, body)));
};
var Card_layouts_Column1 = function Column1(header, body, media) {
  return Card_layouts_jsx(react["Fragment"], null, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12')
  }, media), header && Card_layouts_jsx("div", {
    className: media && 'mt-20'
  }, header), body && Card_layouts_jsx("div", {
    className: (media || header) && 'mt-20'
  }, body));
};
var Column2 = function Column2(header, body, media) {
  return Card_layouts_jsx("div", {
    className: "h-full overflow-hidden rounded-12 shadow-subtle"
  }, media && Card_layouts_jsx("div", {
    className: "-mx-1 -mt-1"
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: "p-20"
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-20'
  }, body)));
};
var Card_layouts_Composite1 = function Composite1(header, body, media) {
  return Card_layouts_jsx(react["Fragment"], null, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12')
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex flex-col sm:flex-row gap-20', {
      'mt-20': media
    })
  }, header && Card_layouts_jsx("div", {
    className: "sm:flex-1"
  }, header), body && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('sm:flex-1', {
      'mt-20': header
    })
  }, body)));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/Card.jsx

var Card_jsx = react_default.a.createElement;







var Card_Card = function Card(_ref) {
  var className = _ref.className,
      closeLabel = _ref.closeLabel,
      color = _ref.color,
      ctaLabel = _ref.ctaLabel,
      customMedia = _ref.customMedia,
      dataTestIdPrefix = _ref.dataTestIdPrefix,
      displayLoadMore = _ref.displayLoadMore,
      hasFullScreenMode = _ref.hasFullScreenMode,
      heading = _ref.heading,
      id = _ref.id,
      introduction = _ref.introduction,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? Card_constants["d" /* INLINE_1 */] : _ref$layout,
      link = _ref.link,
      media = _ref.media,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var hasTitle = Boolean(heading === null || heading === void 0 ? void 0 : heading.title);
  var hasCta = Boolean(ctaLabel);
  var header = !(introduction === null || introduction === void 0 ? void 0 : introduction.text) && !hasTitle ? null : Card_jsx(CardHeader_CardHeader, {
    color: color,
    dataTestIdPrefix: dataTestIdPrefix,
    heading: heading,
    introduction: introduction,
    link: hasCta ? null : link,
    theme: theme
  });
  var body = !(text === null || text === void 0 ? void 0 : text.text) && !hasCta ? null : Card_jsx(CardBody_CardBody, {
    ctaLabel: ctaLabel,
    dataTestIdPrefix: dataTestIdPrefix,
    displayLoadMore: displayLoadMore,
    isTablet: isTablet,
    layout: layout,
    link: link,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    text: text,
    theme: theme
  });
  var picture = !(media === null || media === void 0 ? void 0 : media.url) && !customMedia ? null : Card_jsx(CardMedia_CardMedia, {
    closeLabel: closeLabel,
    hasFullScreenMode: hasFullScreenMode,
    link: hasCta || hasTitle ? null : link,
    media: media,
    theme: theme,
    title: heading === null || heading === void 0 ? void 0 : heading.title
  }, customMedia);
  return body || header || picture ? Card_jsx("article", {
    className: className,
    id: id
  }, Card_layouts_namespaceObject[layout](header, body, picture, dataTestIdPrefix)) : null;
};

/***/ }),

/***/ "A0wc":
/***/ (function(module, exports) {

/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseIndexOfWith;


/***/ }),

/***/ "DyR2":
/***/ (function(module, exports, __webpack_require__) {

var basePullAll = __webpack_require__("v5ZW");

/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? basePullAll(array, values)
    : array;
}

module.exports = pullAll;


/***/ }),

/***/ "GzVq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTabsBackgroundClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTabsMainId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTabsItemIds; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("m1JM");
/* harmony import */ var _color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");




var getTabsBackgroundClasses = function getTabsBackgroundClasses() {
  var hasBackground = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].PEARL;
  return hasBackground ? "bg-".concat(color, " border-b-1 border-t-1 border-grey") : '';
};
var getTabsMainId = function getTabsMainId() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var list = items.filter(Boolean).map(function (_ref) {
    var header = _ref.header,
        title = _ref.title;
    return header && Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(header.title) || title && Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(title);
  }).filter(Boolean);
  return Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* generateUniqueId */ "b"])(list, 'tabs-');
};
var getTabsItemIds = function getTabsItemIds(_ref2) {
  var id = _ref2.id,
      title = _ref2.title,
      index = _ref2.index,
      mainId = _ref2.mainId;
  var headerId = id || Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* generateUniqueId */ "b"])([mainId, Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(title), "".concat(index)], 'tabs-header-');
  var panelId = Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* generateUniqueId */ "b"])([mainId, Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(title), id && "".concat(id), "".concat(index)], 'tabs-panel-');
  return [headerId, panelId];
};

/***/ }),

/***/ "JFtY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__("oNVP");
var imageExtensions = __webpack_require__("y147");
var exts = Object.create(null);

imageExtensions.forEach(function (el) {
	exts[el] = true;
});

module.exports = function (filepath) {
	return path.extname(filepath).slice(1).toLowerCase() in exts;
};


/***/ }),

/***/ "JhHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVideoUrl; });
/* unused harmony export getVideoThumbnail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isVideoUrl; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("iKE+");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_4__);





var youtubeRegEx = new RegExp('https://(?:youtu.be/|www.youtube.com/(?:watch\\?v=|embed/))([a-zA-Z0-9_-]+)');
var youkuRegEx = new RegExp('https?://(?:player.youku.com/embed/|player.youku.com/player.php/sid/)([a-zA-Z0-9]+)');

function getYoutubeVideoUrl(url) {
  var urlId = youtubeRegEx.exec(url);
  return urlId ? "https://www.youtube.com/embed/".concat(urlId[1]) : null;
}

function getYoutubeThumbnail(url) {
  var urlId = youtubeRegEx.exec(url);
  return urlId ? "https://img.youtube.com/vi/".concat(urlId[1], "/sddefault.jpg") : null;
}

function getYoukuVideoUrl(url) {
  var urlId = youkuRegEx.exec(url);
  var clientId = _config__WEBPACK_IMPORTED_MODULE_4___default.a.get('youku.clientId');
  return urlId ? "https://player.youku.com/embed/".concat(urlId[1], "?client_id=").concat(clientId) : null;
}

function getVideoUrl(url) {
  return getYoutubeVideoUrl(url) || getYoukuVideoUrl(url);
}

function getVideoThumbnail(url) {
  return getYoutubeThumbnail(url);
}

function isVideoUrl(url) {
  return youtubeRegEx.test(url) || youkuRegEx.test(url);
}



/***/ }),

/***/ "VBBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextSeeMore; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NPTU");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qqKu");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var TextSeeMore = function TextSeeMore(_ref) {
  var className = _ref.className,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'TextSeeMore' : _ref$dataTestIdPrefix,
      hasNoScrollOnCollapse = _ref.hasNoScrollOnCollapse,
      isCollapseEnabled = _ref.isCollapseEnabled,
      offsetScrollSelector = _ref.offsetScrollSelector,
      onClick = _ref.onClick,
      seeMoreColor = _ref.seeMoreColor,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreSize = _ref.seeMoreSize,
      textProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["className", "dataTestIdPrefix", "hasNoScrollOnCollapse", "isCollapseEnabled", "offsetScrollSelector", "onClick", "seeMoreColor", "seeLessLabel", "seeMoreLabel", "seeMoreSize"]);

  return __jsx(_see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__[/* SeeMore */ "a"], {
    className: className,
    color: seeMoreColor,
    hasNoScrollOnCollapse: hasNoScrollOnCollapse,
    isCollapseEnabled: isCollapseEnabled,
    offsetScrollSelector: offsetScrollSelector,
    onClick: onClick,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: seeMoreSize
  }, __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_4__[/* Text */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, textProps, {
    "data-testid": "".concat(dataTestIdPrefix, "-text")
  })));
};

/***/ }),

/***/ "VO9w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Notification_Notification; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/frameworks/notification/Notification.themes.js
var themes = {
  "default": {
    thRoot: 'relative isolate flex items-start rounded-12 border-1 border-current bg-white p-10 text-sienna',
    thInner: 'flex flex-col flex-1 sm:items-center sm:flex-row',
    thIcon: 'pt-5 pe-10',
    thMessage: 'sm:flex-1 p-10',
    thTitle: 'font-bold font-sans text-14 text-current',
    thText: 'font-sans text-14',
    thTextTheme: 'text-sans-n1',
    thSlot: 'max-w-full overflow-hidden p-10',
    thCloseButton: 'absolute p-10 end-0 top-0 z-1',
    thCloseButtonLabel: 'sr-only'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/notification/Notification.jsx


var __jsx = react_default.a.createElement;






var Notification_Notification = function Notification(_ref) {
  var children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      hasClose = _ref.hasClose,
      _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === void 0 ? icons["a" /* ICONS */].LIGHTBULB : _ref$iconName,
      _ref$iconWidth = _ref.iconWidth,
      iconWidth = _ref$iconWidth === void 0 ? '1.875rem' : _ref$iconWidth,
      id = _ref.id,
      onClose = _ref.onClose,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "className", "closeLabel", "hasClose", "iconName", "iconWidth", "id", "onClose", "text", "theme", "title"]);

  if (!title && !text && !react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thIcon = _themes$theme.thIcon,
      thInner = _themes$theme.thInner,
      thMessage = _themes$theme.thMessage,
      thRoot = _themes$theme.thRoot,
      thSlot = _themes$theme.thSlot,
      thText = _themes$theme.thText,
      thTextTheme = _themes$theme.thTextTheme,
      thTitle = _themes$theme.thTitle;
  return __jsx("div", Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    id: id
  }), !!iconName && __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('leading-0', thIcon)
  }, __jsx(Icon["a" /* Icon */], {
    name: iconName,
    width: iconWidth
  })), __jsx("div", {
    className: thInner
  }, (text || title) && __jsx("div", {
    className: thMessage
  }, !!title && !text && __jsx("p", {
    className: Object(classnames_utils["a" /* classnames */])('m-0', thTitle)
  }, title), !!title && !!text && __jsx("h3", {
    className: Object(classnames_utils["a" /* classnames */])(thTitle)
  }, title), __jsx(Text["a" /* Text */], {
    className: thText,
    text: text,
    theme: thTextTheme
  })), react["Children"].count(children) > 0 && __jsx("div", {
    className: thSlot
  }, children)), hasClose && onClose && __jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])('leading-0', thCloseButton),
    onClick: onClose,
    type: "button"
  }, !!closeLabel && __jsx("span", {
    className: thCloseButtonLabel
  }, closeLabel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "0.625rem"
  })));
};

/***/ }),

/***/ "ZKlR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TabHeader; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/tab-header/TabHeader.themes.js




var themes = {
  "default": function _default(_ref) {
    var _classnames;

    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref$color,
        isAccordion = _ref.isAccordion,
        isActive = _ref.isActive;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('flex font-bold font-sans gap-5 items-center px-20 py-10 rounded-pill text-16 text-black transition-colors duration-250 ease-in whitespace-nowrap', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "border-1 border-".concat(color), isAccordion), Object(defineProperty["a" /* default */])(_classnames, "bg-white hocus:bg-".concat(color, " hocus:text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][color]), !isActive), Object(defineProperty["a" /* default */])(_classnames, "bg-".concat(color, " text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][color]), isActive), _classnames)),
      thIcon: 'shrink-0',
      thIconWidth: '1em'
    };
  },
  simple: function simple(_ref2) {
    var _classnames2;

    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref2$color,
        isActive = _ref2.isActive;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('border-1 flex font-bold font-sans gap-5 items-center p-10 rounded-12 text-12 text-center transition-colors duration-250 ease-in uppercase', (_classnames2 = {}, Object(defineProperty["a" /* default */])(_classnames2, "bg-white hocus:bg-".concat(color, " border-lightGrey hocus:border-").concat(color, " hocus:text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][color]), !isActive), Object(defineProperty["a" /* default */])(_classnames2, "arrow-down arrow-".concat(color, " bg-").concat(color, " border-").concat(color, " text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][color]), isActive), _classnames2)),
      thIcon: 'shrink-0',
      thIconWidth: '1em'
    };
  },
  underlined: function underlined(_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colors["a" /* COLORS */].SIENNA : _ref3$color,
        isActive = _ref3.isActive;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('border-b-2 border-current flex font-bold gap-5 h-full items-center overflow-hidden shrink-0 text-16', Object(defineProperty["a" /* default */])({
        'text-mediumGrey': !isActive
      }, "text-".concat(color), isActive)),
      thIcon: 'shrink-0',
      thIconWidth: '1em'
    };
  },
  rounded: function rounded(_ref4) {
    var _ref4$color = _ref4.color,
        color = _ref4$color === void 0 ? colors["a" /* COLORS */].SIENNA : _ref4$color,
        isActive = _ref4.isActive;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('border-1 border-lightGrey flex gap-5 items-center overflow-hidden rounded-t-12', Object(defineProperty["a" /* default */])({
        'bg-pearl': !isActive
      }, "arrow-down-top arrow-".concat(color, " bg-white border-b-0"), isActive)),
      thIcon: 'shrink-0',
      thIconWidth: '1em'
    };
  },
  flat: function flat(_ref5) {
    var isActive = _ref5.isActive;
    return {
      thRoot: Object(classnames_utils["a" /* classnames */])('border-1 flex h-full items-center p-10 md:px-20 rounded-2 transition-colors duration-250 ease-in', {
        'bg-pearl': !isActive,
        'bg-white border-b-0': isActive
      }),
      thIcon: 'shrink-0',
      thIconWidth: '1em'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tab-header/TabHeader.jsx










var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






// $FlowFixMe
var TabHeader = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var children = props.children,
      className = props.className,
      controlsId = props.controlsId,
      _props$dataTestId = props.dataTestId,
      dataTestId = _props$dataTestId === void 0 ? 'tab-header' : _props$dataTestId,
      iconName = props.iconName,
      id = props.id,
      isAccordion = props.isAccordion,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      _onClick = props.onClick,
      onKeyDown = props.onKeyDown,
      role = props.role,
      style = props.style,
      tabIndex = props.tabIndex,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      trackingData = props.trackingData;
  var tracker = Object(useTracking["a" /* useTracking */])();
  var track = !isActive && trackingData ? function () {
    return tracker(trackingData);
  } : noop_default.a;

  var _themes$theme = themes[theme](props),
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot;

  var aria = _objectSpread(_objectSpread({}, controlsId ? {
    'aria-controls': controlsId
  } : null), isAccordion ? {
    'aria-expanded': isActive
  } : {
    'aria-selected': isActive
  });

  return __jsx("button", Object(esm_extends["a" /* default */])({}, aria, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    "data-cs-override-id": "TabHeader" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
    ,
    "data-testid": dataTestId,
    disabled: isDisabled,
    onClick: function onClick() {
      _onClick && _onClick();
      track();
    },
    onKeyDown: onKeyDown,
    id: id,
    ref: ref,
    role: role,
    style: style,
    tabIndex: tabIndex,
    type: "button"
  }), !!iconName && __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: iconName,
    width: thIconWidth
  }), children);
});

/***/ }),

/***/ "akds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Video; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("pKEY");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazyload__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("u/u4");
/* harmony import */ var _image_placeholder_ImagePlaceholder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("D0nZ");
/* harmony import */ var _Video_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JhHq");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






function Video(props) {
  var className = props.className,
      iFrameClassName = props.iFrameClassName,
      _props$ratioKey = props.ratioKey,
      ratioKey = _props$ratioKey === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__[/* default */ "c"].L : _props$ratioKey,
      url = props.url;

  if (!Object(_Video_utils__WEBPACK_IMPORTED_MODULE_5__[/* isVideoUrl */ "b"])(url)) {
    return null;
  }

  return __jsx(_image_placeholder_ImagePlaceholder__WEBPACK_IMPORTED_MODULE_4__[/* ImagePlaceholder */ "a"], {
    aspectRatio: 100 * _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__[/* default */ "c"].VALUES[ratioKey],
    className: className
  }, __jsx(react_lazyload__WEBPACK_IMPORTED_MODULE_2___default.a, {
    className: "bg-no-repeat bg-center bg-cover leading-0 flex h-full items-center justify-center overflow-hidden rounded-12",
    once: true,
    offset: 100
  }, __jsx("iframe", {
    loading: "lazy",
    title: "Video iframe",
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])(iFrameClassName, 'border-0 animate-fadeIn animation-duration-500 h-[54vw] w-[96vw] max-h-full lazy'),
    src: Object(_Video_utils__WEBPACK_IMPORTED_MODULE_5__[/* getVideoUrl */ "a"])(url),
    allowFullScreen: true
  })));
}

/***/ }),

/***/ "jHPj":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("R3TX"),
    pullAll = __webpack_require__("DyR2");

/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = baseRest(pullAll);

module.exports = pull;


/***/ }),

/***/ "lW4u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withOpenAndScrollToHash; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zygG");
/* harmony import */ var lodash_upperCase__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("4xcl");
/* harmony import */ var lodash_upperCase__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_upperCase__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("RUiN");
/* harmony import */ var _tabs_util__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("GzVq");













var __jsx = react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function getWithIds(_ref) {
  var id = _ref.id,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  var mainId = id || Object(_tabs_util__WEBPACK_IMPORTED_MODULE_17__[/* getTabsMainId */ "c"])(items);
  var itemsWithIds = items.map(function (item, index) {
    var _getTabsItemIds = Object(_tabs_util__WEBPACK_IMPORTED_MODULE_17__[/* getTabsItemIds */ "b"])({
      id: item.headerId,
      index: index,
      mainId: mainId,
      title: item.header && item.header.title
    }),
        _getTabsItemIds2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(_getTabsItemIds, 2),
        headerId = _getTabsItemIds2[0],
        panelId = _getTabsItemIds2[1];

    return _objectSpread(_objectSpread({}, item), {}, {
      headerId: headerId,
      panelId: panelId
    });
  });
  return [mainId, itemsWithIds];
}
/* scroll to Tabs or Accordion item #id and open it */


function withOpenAndScrollToHash(WrappedComponent) {
  return function OpenTabAndScrollToHash(props) {
    var _useState = Object(react__WEBPACK_IMPORTED_MODULE_13__["useState"])({
      initialSelectedItem: props.initialSelectedItem || 0,
      initialSelectedItems: props.initialSelectedItems || [0]
    }),
        _useState$ = _useState[0],
        initialSelectedItem = _useState$.initialSelectedItem,
        initialSelectedItems = _useState$.initialSelectedItems,
        setInitialItems = _useState[1];

    var _getWithIds = getWithIds({
      id: props.id,
      items: props.items
    }),
        _getWithIds2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(_getWithIds, 2),
        mainId = _getWithIds2[0],
        itemsWithIds = _getWithIds2[1];

    var router = Object(next_router__WEBPACK_IMPORTED_MODULE_14__["useRouter"])();
    var uri = new urijs__WEBPACK_IMPORTED_MODULE_15___default.a(router.asPath);
    var urihash = uri.hash();

    var hashChangeHandler = function hashChangeHandler(hash) {
      var ids = itemsWithIds.map(function (_ref2) {
        var _ref2$headerId = _ref2.headerId,
            headerId = _ref2$headerId === void 0 ? '' : _ref2$headerId;
        return "#".concat(lodash_upperCase__WEBPACK_IMPORTED_MODULE_12___default()(headerId));
      });
      var index = ids.indexOf("#".concat(lodash_upperCase__WEBPACK_IMPORTED_MODULE_12___default()(hash)));

      if (index !== -1) {
        setInitialItems({
          initialSelectedItem: index,
          initialSelectedItems: [index]
        });
        Object(_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_16__[/* scrollToElement */ "a"])("#".concat(mainId), 100);
      } else {
        setInitialItems({
          initialSelectedItem: 0,
          initialSelectedItems: [0]
        });
      }
    };

    Object(react__WEBPACK_IMPORTED_MODULE_13__["useEffect"])(function () {
      if (urihash) {
        hashChangeHandler(urihash);
      }
    }, [urihash]);
    return __jsx(WrappedComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])({}, props, {
      id: mainId,
      initialSelectedItems: initialSelectedItems,
      initialSelectedItem: initialSelectedItem,
      setInitialItems: setInitialItems,
      items: itemsWithIds,
      key: mainId // to reinitialize state when it is new tabs, see : https://fr.reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-uncontrolled-component-with-a-key

    }));
  };
}

/***/ }),

/***/ "oNVP":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "syQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INLINE_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INLINE_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLUMN_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COLUMN_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMPOSITE_1; });
var INLINE_1 = 'Inline1';
var INLINE_2 = 'Inline2';
var COLUMN_1 = 'Column1';
var COLUMN_2 = 'Column2';
var COMPOSITE_1 = 'Composite1';

/***/ }),

/***/ "uFXj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var createHTML = __webpack_require__("gIHd");
var forcedStringHTMLMethod = __webpack_require__("sHxg");

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});


/***/ }),

/***/ "v5ZW":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("H87J"),
    baseIndexOf = __webpack_require__("c7Qd"),
    baseIndexOfWith = __webpack_require__("A0wc"),
    baseUnary = __webpack_require__("SU8Q"),
    copyArray = __webpack_require__("QT01");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = copyArray(values);
  }
  if (iteratee) {
    seen = arrayMap(array, baseUnary(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice.call(seen, fromIndex, 1);
      }
      splice.call(array, fromIndex, 1);
    }
  }
  return array;
}

module.exports = basePullAll;


/***/ }),

/***/ "vLcP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/card/Card.constants.js
var Card_constants = __webpack_require__("syQ6");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/client/components/frameworks/card/Card.jsx + 11 modules
var Card = __webpack_require__("786X");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.utils.js
var Datepicker_utils = __webpack_require__("szYs");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/utils/graphql/index.js
var graphql = __webpack_require__("NLwV");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/client/components/lines/qrcode-product-program/qrcodeProductProgramLine.utils.js


var __jsx = react_default.a.createElement;
/* eslint-disable clubmed/no-fake-component */














 // Implementation carried on the component side to correct the problem of the timezone of the resort

var getActivitiesQuery = function getActivitiesQuery(productArgs, firstDate, lastDate) {
  return "\nquery {\n    resort(".concat(productArgs, ") {\n      planning(type: \"ACTIVITY\", firstDate: \"").concat(firstDate, "\", lastDate: \"").concat(lastDate, "\") {\n        endDateTime\n        image\n        label\n        locationLabel\n        startDateTime\n        weekdayName\n      }\n    }\n  }");
};

var qrcodeProductProgramLine_utils_getPlanningActivities = function getPlanningActivities(resortId, appContext) {
  var productArgs = Object(graphql["c" /* buildProductArgs */])(resortId);
  var firstDate = moment_default()().format(apiDate["a" /* API_DATE_FORMAT */]);
  var lastDate = moment_default()(firstDate, apiDate["a" /* API_DATE_FORMAT */]).add(7, 'days').format(apiDate["a" /* API_DATE_FORMAT */]);
  var response = graphqlClient["a" /* default */].runQuery(getActivitiesQuery(productArgs, firstDate || '', lastDate || ''), appContext, {
    requestName: requestDictionary["hc" /* LINE_QRCODE_PRODUCT_PROGRAM */]
  });
  return response;
};
var qrcodeProductProgramLine_utils_getTabsItems = function getTabsItems(_ref) {
  var associatedActivities = _ref.associatedActivities,
      displayedDays = _ref.displayedDays,
      language = _ref.language,
      programMissingText = _ref.programMissingText,
      programMissingTitle = _ref.programMissingTitle;
  return displayedDays.map(function (day, index) {
    var dayName = associatedActivities[index].length > 0 ? associatedActivities[index][0].weekdayName : Object(Datepicker_utils["formatWeekdayLong"])(day.day(), language);
    var content = associatedActivities[index].length > 0 ? associatedActivities[index].map(function (_ref2) {
      var endDateTime = _ref2.endDateTime,
          image = _ref2.image,
          label = _ref2.label,
          locationLabel = _ref2.locationLabel,
          startDateTime = _ref2.startDateTime;
      var momentStartTime = moment_default()(startDateTime, apiDate["c" /* UTC_DATE_TIME_FORMAT */]);
      var momentEndTime = moment_default()(endDateTime, apiDate["c" /* UTC_DATE_TIME_FORMAT */]);
      var duration = momentEndTime.diff(momentStartTime, 'minutes');
      return __jsx("div", {
        key: "programDay".concat(index),
        className: "flex flex-col"
      }, __jsx("div", {
        className: "flex min-h-32 items-center rounded-4 border-s-1 border-sienna font-brand text-16 font-normal leading-tight text-black md:text-18"
      }, __jsx("span", {
        className: "whitespace-nowrap pl-10 pr-10"
      }, "".concat(momentStartTime.format('HH:mm'), " - ").concat(momentEndTime.format('HH:mm'))), __jsx("hr", {
        className: "mx-0 my-10 block h-1 w-full border-0 border-t-1 border-solid border-mediumGrey p-0 md:my-15 lg:my-20"
      })), __jsx("div", {
        className: "mb-30 mt-10 flex h-full overflow-hidden rounded-12 border-1 border-lightGrey shadow-diffuse"
      }, __jsx(Image["b" /* default */], {
        className: "me-10 w-1/2 md:me-15 lg:me-20",
        classNameImg: "overflow-hidden",
        imageUrl: image,
        key: image,
        groupKey: "program-images",
        ratioKey: ratios_utils["c" /* default */].XL,
        ratioDisplay: 1 / 3
      }), __jsx("div", {
        className: "mb-10 mt-10 flex min-h-full flex-1 flex-col justify-between md:mb-15 md:mt-15 lg:mb-20 lg:mt-20"
      }, __jsx("span", {
        className: "text-16 font-bold leading-tight text-black"
      }, label), __jsx("div", {
        className: "flex h-full flex-col justify-end"
      }, __jsx("div", {
        className: "flex pe-10 pt-10 text-14 font-normal leading-tight text-black md:pe-15 md:pt-15 md:text-16 lg:pe-20 lg:pt-20"
      }, __jsx(Icon["a" /* Icon */], {
        className: "transition-transform me-5 text-sienna duration-250 ease-in",
        name: icons["a" /* ICONS */].ADDRESS,
        width: "1rem"
      }), __jsx("span", null, locationLabel)), __jsx("div", {
        className: "flex pt-10 text-14 font-normal leading-tight text-black md:text-16"
      }, __jsx(Icon["a" /* Icon */], {
        className: "transition-transform me-5 text-sienna duration-250 ease-in",
        name: icons["a" /* ICONS */].DURATION,
        width: "1rem"
      }), __jsx("span", null, "".concat(duration, " min")))))));
    }) : [__jsx(Card["a" /* Card */], {
      color: colors["a" /* COLORS */].SIENNA,
      heading: {
        iconName: icons["a" /* ICONS */].ACTIVITIES,
        title: programMissingTitle
      },
      key: "programDay".concat(index),
      layout: Card_constants["b" /* COLUMN_2 */],
      text: {
        text: programMissingText
      }
    })];
    return {
      header: {
        title: __jsx("div", {
          className: "whitespace-nowrap capitalize",
          title: dayName
        }, "".concat(dayName, " ").concat(day.format('DD')))
      },
      content: content,
      headerId: "resortPlanningProgramDay".concat(index, "Header"),
      panelId: "resortPlanningProgramDay".concat(index, "Panel")
    };
  });
};
// CONCATENATED MODULE: ./src/client/components/lines/qrcode-product-program/QrcodeProductProgramLine.jsx




var QrcodeProductProgramLine_jsx = react_default.a.createElement;















var NUMBER_OF_DISPLAYED_DAYS = 7;
var QrcodeProductProgramLine_QrcodeProductProgramLine = function QrcodeProductProgramLine(_ref) {
  var noProgramText = _ref.noProgramText,
      noProgramTitle = _ref.noProgramTitle,
      programMissingText = _ref.programMissingText,
      programMissingTitle = _ref.programMissingTitle,
      resortId = _ref.resortId,
      title = _ref.title;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useState = Object(react["useState"])([]),
      activitiesPlanning = _useState[0],
      setActivitiesPlanning = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isActivitiesPlanningLoading = _useState2[0],
      setIsActivitiesPlanningLoading = _useState2[1]; // Implementation carried on the component side to correct the problem of the timezone of the resort


  Object(react["useEffect"])(function () {
    var fetchResortPlanningActivities = /*#__PURE__*/function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _yield$getPlanningAct, planning;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setIsActivitiesPlanningLoading(true);
                _context.next = 3;
                return qrcodeProductProgramLine_utils_getPlanningActivities(resortId, appContext);

              case 3:
                _yield$getPlanningAct = _context.sent;
                planning = _yield$getPlanningAct.resort.planning;
                setActivitiesPlanning(planning);
                setIsActivitiesPlanningLoading(false);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchResortPlanningActivities() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchResortPlanningActivities();
  }, []);
  var trackingData = {
    categoryGA: 'landingPage',
    actionGA: 'CTA_ProgrammeDressCodeDate'
  };
  var track = Object(useTracking["a" /* useTracking */])(trackingData);
  var language = appContext.locale.slice(0, 2);
  var displayedDays = [];
  var associatedActivities = [];

  if (activitiesPlanning.length > 0) {
    var _loop = function _loop(i) {
      var day = moment_default()().locale(language).add(i, 'days');
      displayedDays.push(day);
      associatedActivities.push(activitiesPlanning.filter(function (_ref3) {
        var startDateTime = _ref3.startDateTime;
        return day.dayOfYear() === moment_default()(startDateTime, apiDate["c" /* UTC_DATE_TIME_FORMAT */]).dayOfYear();
      }));
    };

    for (var i = 0; i < NUMBER_OF_DISPLAYED_DAYS; i++) {
      _loop(i);
    }
  }

  return QrcodeProductProgramLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: "QrcodeProductProgramLine",
    size: "small"
  }, QrcodeProductProgramLine_jsx(LineTitle["a" /* LineTitle */], null, title), isActivitiesPlanningLoading && QrcodeProductProgramLine_jsx("div", {
    className: "flex justify-center items-center"
  }, QrcodeProductProgramLine_jsx(Spinner["a" /* Spinner */], {
    size: "small"
  })), !isActivitiesPlanningLoading && (displayedDays.length > 0 ? QrcodeProductProgramLine_jsx(Tabs["a" /* Tabs */], {
    className: "mt-20",
    hasControlsOnTouch: true,
    isContainerWide: true,
    isScrollable: true,
    items: qrcodeProductProgramLine_utils_getTabsItems({
      associatedActivities: associatedActivities,
      displayedDays: displayedDays,
      language: language,
      programMissingText: programMissingText,
      programMissingTitle: programMissingTitle
    }),
    onTabClick: function onTabClick(_, index) {
      var dayLabel = index === 0 ? 'Today' : "Day_".concat(index);
      track({
        labelGA: "%Tab".concat(dayLabel, "%")
      });
    },
    theme: "underlined"
  }) : QrcodeProductProgramLine_jsx(Card["a" /* Card */], {
    color: colors["a" /* COLORS */].SIENNA,
    heading: {
      iconName: icons["a" /* ICONS */].DURATION,
      title: noProgramTitle
    },
    layout: Card_constants["b" /* COLUMN_2 */],
    text: {
      text: noProgramText
    }
  })));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/qrcode-product-program/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (QrcodeProductProgramLine_QrcodeProductProgramLine);

/***/ }),

/***/ "y147":
/***/ (function(module) {

module.exports = JSON.parse("[\"ase\",\"art\",\"bmp\",\"blp\",\"cd5\",\"cit\",\"cpt\",\"cr2\",\"cut\",\"dds\",\"dib\",\"djvu\",\"egt\",\"exif\",\"gif\",\"gpl\",\"grf\",\"icns\",\"ico\",\"iff\",\"jng\",\"jpeg\",\"jpg\",\"jfif\",\"jp2\",\"jps\",\"lbm\",\"max\",\"miff\",\"mng\",\"msp\",\"nitf\",\"ota\",\"pbm\",\"pc1\",\"pc2\",\"pc3\",\"pcf\",\"pcx\",\"pdn\",\"pgm\",\"PI1\",\"PI2\",\"PI3\",\"pict\",\"pct\",\"pnm\",\"pns\",\"ppm\",\"psb\",\"psd\",\"pdd\",\"psp\",\"px\",\"pxm\",\"pxr\",\"qfx\",\"raw\",\"rle\",\"sct\",\"sgi\",\"rgb\",\"int\",\"bw\",\"tga\",\"tiff\",\"tif\",\"vtf\",\"xbm\",\"xcf\",\"xpm\",\"3dv\",\"amf\",\"ai\",\"awg\",\"cgm\",\"cdr\",\"cmx\",\"dxf\",\"e2d\",\"egt\",\"eps\",\"fs\",\"gbr\",\"odg\",\"svg\",\"stl\",\"vrml\",\"x3d\",\"sxd\",\"v2d\",\"vnd\",\"wmf\",\"emf\",\"art\",\"xar\",\"png\",\"webp\",\"jxr\",\"hdp\",\"wdp\",\"cur\",\"ecw\",\"iff\",\"lbm\",\"liff\",\"nrrd\",\"pam\",\"pcx\",\"pgf\",\"sgi\",\"rgb\",\"rgba\",\"bw\",\"int\",\"inta\",\"sid\",\"ras\",\"sun\",\"tga\"]");

/***/ })

}]);